import GetInShape from '../../pages/get-in-shape/GetInShape'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.GET_IN_SHAPE, component: GetInShape },
])
